import React, { ReactElement } from "react";
import Head from "next/head";
import Blog from "@/components/koach/Guides/Blog";
import Signup from "@/components/koach/Signup";
import getConfig from "next/config";
import { MainLayout } from "@/containers/layout/KoachLayout";

const Koach = (): JSX.Element => {
  return (
    <>
      <Head>
        <title>Guides for Saving & Spending Smarter with Klink</title>
        <link rel="canonical" href="https://www.klink-app.com/guides" />
        <meta
          name="description"
          content="Explore Klink's comprehensive guides to homeownership. Learn smart saving strategies and steps to secure your future home."
        />

        <meta
          name="twitter:card"
          content="Explore Klink's comprehensive guides to homeownership. Learn smart saving strategies and steps to secure your future home."
          key="twcard"
        />
        <meta name="twitter:url" content="https://www.klink-app.com/guides" />
        <meta
          name="twitter:title"
          content="Guides for Saving & Spending Smarter with Klink"
        />
        <meta name="twitter:image" content="/meta-opengraph-landing.png" />
        <meta name="twitter:creator" content="klink_app" key="twhandle" />

        <meta
          property="og:url"
          content="https://www.klink-app.com/guides"
          key="ogurl"
        />
        <meta property="og:url" content="/" key="ogurl" />
        <meta
          property="og:image"
          content="/meta-opengraph-guide.png"
          key="ogimage"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Klink" key="ogsitename" />
        <meta
          property="og:title"
          content="Guides for Saving & Spending Smarter with Klink"
          key="ogtitle"
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_GB" />
        <meta
          property="og:description"
          content="Explore Klink's comprehensive guides to homeownership. Learn smart saving strategies and steps to secure your future home."
          key="ogdesc"
        />
      </Head>
      <div className="bg-white">
        <Blog />
        <div className="flex gap-6 flex-col justify-center items-center">
          <p className="text-center w-full text-xl md:text-2xl text-light-White text-center font-thin mb-6 md:mt-5 max-w-sm  md:max-w-md lg:max-w-3xl leading-normal">
            Do you have a burning question about financial health, joining the
            property ladder or getting approved for a mortgage?{" "}
            <a
              href="mailto:hello@klink-app.com"
              target="_blank"
              rel="noreferrer"
              className="font-bold text-center text-magenta"
            >
              Email us
            </a>{" "}
            your request for a knowledge guide!
          </p>
        </div>
        <Signup />
      </div>
    </>
  );
};

Koach.getLayout = function getLayout(page: ReactElement) {
  return (
    <>
      <MainLayout theme="dark">{page}</MainLayout>
    </>
  );
};

export default Koach;
